import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatDivider } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatOption, MatSelect } from '@angular/material/select';
import { RouterModule } from '@angular/router';
import { LoginPermissionsComponent } from './login-permissions.component';

@NgModule({
  declarations: [LoginPermissionsComponent],
  exports: [LoginPermissionsComponent],
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    RouterModule,
    MatInputModule,
    MatSelect,
    MatOption,
    MatCheckbox,
    MatIcon,
    MatProgressSpinner,
    MatDivider,
  ],
})
export class LoginPermissionsModule {}
